<select2
    #select2Component
    class="form-control select2-form-control {{disabled?'bg-grey':''}} {{field && !disabled && field.iifIsValid('border-success','border-danger')}}"
    [data]="locationSelectData"
    [options]="locationSelectOptions"
    (valueChanged)="valueChanged($event.data)"
    [value]="defaultValue"
    [disabled]="disabled"
  ></select2>